import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BackOfficeInvoiceConfig } from './BackOfficeInvoiceConfig';

export class BackOfficeExpropriationConfig extends BackOfficeInvoiceConfig {
    _originalTypeClassName = "zERP.BO.BackOfficeExpropriationConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeExpropriationConfig.translate = translateService;
}
super();
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
GoodForIncome:any;
TameioNomikon:any;
TameioSynergasias:any;
DSA:any;
GoodForExpense:any;
CashAccount:any;
static setGoodForIncome = ($this, value) => {
var oldValue = $this.GoodForIncome;
$this.GoodForIncome = value;
if (value != null) {
}
}
static setTameioNomikon = ($this, value) => {
var oldValue = $this.TameioNomikon;
$this.TameioNomikon = value;
if (value != null) {
}
}
static setTameioSynergasias = ($this, value) => {
var oldValue = $this.TameioSynergasias;
$this.TameioSynergasias = value;
if (value != null) {
}
}
static setDSA = ($this, value) => {
var oldValue = $this.DSA;
$this.DSA = value;
if (value != null) {
}
}
static setGoodForExpense = ($this, value) => {
var oldValue = $this.GoodForExpense;
$this.GoodForExpense = value;
if (value != null) {
}
}
static setCashAccount = ($this, value) => {
var oldValue = $this.CashAccount;
$this.CashAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}